import * as React from 'react';
import { useState, useEffect } from 'react';

/** Material UI Packages. */
import { Box, Tabs, Tab, TextField, Tooltip } from '@mui/material';

/** Material UI Icons. */
import ClearIcon from '@mui/icons-material/Clear';
import AddIcon from '@mui/icons-material/Add';

/** Internal Components. */

const UpdateTabs = ({
    value,
    label,
    tabsData,
    tabTitles,
    editIndex,
    isChange,
    handleChange,
    handleDoubleClick,
    handleChangeTabTitle,
    handleKeyDown,
    handleBlur,
    handleDeleteTab,
    handleAddTab,
    tabsStyle,
    tabStyle,
    disableAdd = false,
}) => {
    return (
        <Box
            sx={{
                height: '36px',
                borderBottom: 1,
                borderColor: 'divider',
                p: 0,
                m: 0,
            }}
        >
            <Tabs
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                indicatorColor="secondary"
                sx={{
                    minHeight: '35px',
                    '& .MuiButtonBase-root': {
                        border: 'none',
                        p: 0,
                    },
                    display: 'flex',
                    alignItems: 'center',
                    ...tabsStyle,
                }}
            >
                {tabsData.map((tab, index) => (
                    <Tab
                        key={index}
                        label={
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    px: 0.5,
                                    cursor: 'pointer',
                                    width: '130px',
                                }}
                                onDoubleClick={() => handleDoubleClick(index)}
                            >
                                {editIndex === index ? (
                                    <TextField
                                        value={
                                            isChange && tabTitles[tab.id] !== undefined ? tabTitles[tab.id] : tab[label]
                                        }
                                        onChange={handleChangeTabTitle(index, tab.id)}
                                        onKeyDown={(event) => handleKeyDown(event, tab.id, tab[label])}
                                        onBlur={() => handleBlur(tab.id, tab[label])}
                                        autoFocus
                                        size="small"
                                        variant="outlined"
                                        sx={{
                                            fontSize: '11px',
                                            width: '100%',
                                            '& .MuiOutlinedInput-notchedOutline': {
                                                border: 'none',
                                            },
                                            '& .MuiInputBase-input': {
                                                px: 0,
                                                py: 0,
                                                fontSize: '11px',
                                            },
                                        }}
                                    />
                                ) : (
                                    <Box sx={{ flexGrow: 1, fontSize: '11px', fontWeight: '500' }}>
                                        {tabTitles[tab.id] || tab[label]}
                                    </Box>
                                )}

                                <Box onClick={() => handleDeleteTab(tab)} sx={{ cursor: 'pointer', ml: 0.5 }}>
                                    <Tooltip title="Clear">
                                        <ClearIcon sx={{ fontSize: '1rem', color: '#262626' }} />
                                    </Tooltip>
                                </Box>
                            </Box>
                        }
                        sx={{
                            width: '130px',
                            borderRadius: '5px',
                            minHeight: '35px',
                            bgcolor: value === index ? '#dfdfdf' : 'white',
                            border: '1px solid #dfdfdf',
                            '& .MuiButtonBase-root': { p: 0, m: 0 },
                            ...tabStyle,
                        }}
                    />
                ))}
                <Tab
                    label={
                        <Box sx={{ display: 'flex', alignItems: 'center', px: '3px', m: 0 }}>
                            <Tooltip title="Add">
                                <AddIcon
                                    sx={{
                                        fontSize: '20px',
                                        bgcolor: disableAdd ? '#b0b0b0' : '#003a52',
                                        color: 'white',
                                        borderRadius: 20,
                                    }}
                                />
                            </Tooltip>
                        </Box>
                    }
                    onClick={handleAddTab}
                    disabled={disableAdd}
                    sx={{
                        minHeight: '30px',
                        borderRadius: '5px',
                        minWidth: 'auto',
                        ':hover': { bgcolor: 'white' },
                    }}
                />
            </Tabs>
        </Box>
    );
};
export default React.memo(UpdateTabs);
